import * as React from "react";
import { Link } from "react-router-dom";
import { useUser } from "../../helpers/satiBack";
import { FaChevronRight } from "react-icons/fa";

import HealthWeekBackground from "../../assets/images/contents/Semana de salud.jpg";

import "./styles/dashboard.scss";

const CONTENT_CARDS = [
  {
    background: HealthWeekBackground,
    title: "Semana de salud",
    url: "/healthweek",
  },
];

function ContentCard({ background, title, url }) {
  return (
    <div className="content-card">
      <div className="background" />
      <img src={background} alt={title} loading="lazy" />
      <div className="titles">
        <span>{title}</span>

        <Link to={url}>
          Ver contenido <FaChevronRight />
        </Link>
      </div>
    </div>
  );
}

function Dashboard() {
  const { data, isLoading } = useUser();

  const nombre = data?.data?.nombre || "";

  return (
    <div className="contents-dashboard">
      <div className="heading">
        <span>
          Bienvenido, {isLoading ? "..." : nombre.split(" ")[0] || ""}
        </span>
        <span>
          Tu plataforma de recursos y herramientas como charlas, tutoriales y
          promociones especiales que te ayudarán a mejorar tu salud día con día.
        </span>
      </div>

      <div className="content">
        {CONTENT_CARDS.map((el) => (
          <ContentCard
            key={el.title}
            background={el.background}
            title={el.title}
            url={el.url}
          />
        ))}
      </div>
    </div>
  );
}

export default Dashboard;
